import React from 'react';

import ListResource from '../ListResource.jsx';
import ListCtrlActivates from '../ListCtrlActivates.jsx';

const api = '/api/core/tfy/colors';

const ListColors = () => (
  <ListResource
    {...{
      searchable: true,
      api,
      sort: { name: 1 },
      actions: {
        fileExport: true,
        fileImport: true,
      },
      cols: [
        {
          key: 'image',
          getter: (v) => (v ? (
            <img
              src={v}
              alt={'s'}
              style={{
                maxWidth: '120px',
                maxHeight: '120px',
              }}
            />
          ) : (
            ''
          )),
        },
        { key: 'name', sortable: true, children: 'Name' },
        { key: 'pomId', sortable: true, children: 'Pom Id' },
        { key: 'code', sortable: true, children: 'Color Code' },
        { key: 'hex', sortable: true, children: 'Hex' },
      ],
    }}
  >
    {({ selected, refresh }) => (
      <ListCtrlActivates
        api={api}
        selected={selected}
        onSuccess={refresh}
      />
    )}
  </ListResource>
);

export default ListColors;
